import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import "./ProcessFlow.css";

var processFlowArray = [
  {
    id: 1,
    img: require('../images/ComponentImg/processFlowSensor.jpg'),
    title: 'HLZ Sensor Production Process Flow',
    text: '專業生產 Sensor，from 2"~65"',
    designation: 'Sensor Process Flow',
    link: 'https://www.hlztouch.com'
  },
  {
    id: 2,
    img: require('../images/ComponentImg/processFlowPcap.jpg'),
    title: 'HLZ PCAP Production Process Flow',
    text: '導入TP製程，具備完整觸摸屏產業鏈',
    designation: 'PCAP Process Flow',
    link: 'https://www.hlztouch.com'
  },
  {
    id: 3,
    img: require('../images/ComponentImg/processFlowTdm.jpg'),
    title: 'HLZ TDM Production Process Flow',
    text: '服務客戶投入TP+LCM全貼合生產線',
    designation: 'Touch Display Module Process Flow',
    link: 'https://www.hlztouch.com'
  }
]

export function ProcessFlow() {
  return (
    <section id='processflow' className='processflow-block'>
      <Container fluid>
        <div className='title-holder'>
          <h2 className='text-center'>Production Process</h2>
          {/* <div className="text-center"><h3>what client says about us</h3></div> */}
        </div>
        <Carousel controls={true}> {
          processFlowArray.map(flow => {
            return (
              <Carousel.Item key={flow.id}>
                <div className='subtitle text-center'><h3>{flow.designation}</h3></div>
                <img className='d-block' src={flow.img} alt={flow.id} />
                {/* <img style={{ height: '60vh' }} className='d-block' src={flow.img} alt={flow.id} /> */}
                <Carousel.Caption>
                  <blockquote>
                    <p><h3>{flow.text}</h3></p>
                    <cite>
                      <span className='title'><h3>{flow.title}</h3></span>
                      <span className='designation'><h4>{flow.designation}</h4></span>
                    </cite>
                  </blockquote>
                </Carousel.Caption>
              </Carousel.Item>
            );
          })
        } </Carousel>
      </Container>
    </section>
  );
}

// export default ProcessFlow;